import React from 'react';
// 导入所有静态图片
const 领域广泛 = require('../../static/组建/领域广泛.png');
const 服务升级 = require('../../static/组建/服务号.png');
const 品牌强大 = require('../../static/组建/品牌列表.png');
const 售后保障 = require('../../static/组建/售后.png');
const 第三方服务 = require('../../static/组建/第三方.png');
const 团队实力 = require('../../static/组建/064团队.png');
export const Content00DataSource = {
  wrapper: { className: 'home-page-wrapper content0-wrapper' },
  page: { className: 'home-page content0' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>公司优势</p>
          </span>
        ),
      },
      {
        name: 'content~l5vvmd9ntu',
        className: '',
        children: (
          <span>
            <p>
              计算机网络技术开发、网络平台服务、计算机软硬件开发、政务软件开发、销售及服务
            </p>
          </span>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children:
                领域广泛,
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: (
                <span>
                  <span>
                    <p>领域广泛</p>
                  </span>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <span>
                            <p>
                              涉及政务，教育，社会团体，电商，驾校等各行各业，提供解决方案，技术支持。
                            </p>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block2',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children: 
                品牌强大,
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: (
                <span>
                  <span>
                    <span>
                      <p>品牌强大</p>
                    </span>
                  </span>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <span>
                    <span>
                      <p>
                        专注企业品牌塑造,帮企业提高品牌声量，传播方案，体系化专业服务。
                      </p>
                    </span>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children: 
                团队实力,
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <p>团队实力</p>
                      </span>
                    </span>
                  </span>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <p>
                    研发团队强大的技术支持，建设周期短、成本低，具备低功耗物联网网络特性。
                  </p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block~l5vvmo2evsg',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children: 
                售后保障,
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: (
                <span>
                  <p>售后保障</p>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <span>
                    <p>
                      由经验丰富的信息化咨询顾问来为企业管理诊断，7*24小时响应快速诊断及解决。
                    </p>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block~l5vvmpizvw',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children: 
                服务升级,
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: (
                <span>
                  <p>服务升级</p>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <span>
                    <span>
                      <p>
                        定期更新优化，客户满意是我们永远的目标，用心服务每一位客户。
                      </p>
                    </span>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block~l5vvmqc34bo',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children: 
                第三方服务,
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: (
                <span>
                  <p>第三方服务</p>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <span>
                    <p>
                      我们提供第三方定制服务，根据用户需求灵活定制系统方案。
                    </p>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
    ],
  },
};
